<script lang="ts">
    import {createSortingFromName} from 'src/features/search/kp-search-field-type-filter';
    import {KpPopover} from 'shared/ui-widgets/popover';
    import {Flex} from 'shared/layouts';
    import type {Sorting} from 'src/typings';
    import type {FieldTypeDefinition} from 'src/features/record/field-types/types';
    import {cleanup, exists} from 'shared/utils/custom-utils';
    import {getSearchFieldTypeFiltersContext} from '../search-field-type-filters.context';
    import {onDestroy} from 'svelte';
    import {get} from 'svelte/store';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';

    export let fieldDefinition: FieldTypeDefinition;

    const context = getSearchFieldTypeFiltersContext();

    let activeSorting: Sorting | null = get(context.activeSorting$);
    const activeSortingUnsubscribe = context.activeSorting$.subscribe((sorting) => activeSorting = sorting);

    onDestroy(() => {
        cleanup(activeSortingUnsubscribe);
    });

    function createSorting(sorter: string, type: 'asc' | 'desc') {
        context.setSorting(createSortingFromName(sorter, type));
    }

    function cancelSorting(sorter: string) {
        const sorting = get(context.activeSorting$);
        if (!exists(sorting) || sorting.field !== sorter) {
            return;
        }

        context.setSorting(null);
    }

    function isSortingActive(sorter: string, sorting: Sorting | null): boolean {
        return exists(sorting) && sorting.field === sorter;
    }

    function isSortingAsc(sorter: string, sorting: Sorting | null): boolean {
        return exists(sorting) && sorting.field === sorter && sorting.asc;
    }

    $: sortingActive = exists(fieldDefinition) && isSortingActive(fieldDefinition.valueSorter, activeSorting);
    $: sortingAsc = exists(fieldDefinition) && isSortingAsc(fieldDefinition.valueSorter, activeSorting);
</script>

<KpPopover additionalPopoverButtonClasses="field-type-filter-button {sortingActive ? 'filter-active' : ''}"
           buttonSize="xs"
           buttonStyle="no-background">

    <svelte:fragment slot="button">
        <UIcon icon={sortingActive ? (sortingAsc ? 'sort-alpha-down' : 'sort-alpha-down-alt') : 'sort'}/>
    </svelte:fragment>

    <svelte:fragment slot="popover-content">
        <Flex direction="column" gap="s">
            <KpButton buttonSize="sm" on:click={() => createSorting(fieldDefinition.valueSorter, 'asc')}>
                <IconedContent icon="sort-alpha-down">Vzestupně</IconedContent>
            </KpButton>

            <KpButton buttonSize="sm" on:click={() => createSorting(fieldDefinition.valueSorter, 'desc')}>
                <IconedContent icon="sort-alpha-down-alt">Sestupně</IconedContent>
            </KpButton>

            {#if sortingActive}
                <KpButton buttonSize="sm"
                          buttonStyle="danger"
                          on:click={() => cancelSorting(fieldDefinition.valueSorter)}>

                    <IconedContent icon="cross-circle">Zrušit řazení</IconedContent>
                </KpButton>
            {/if}
        </Flex>
    </svelte:fragment>
</KpPopover>

<style lang="less">
    :global {
        .field-type-filter-button {
            display: flex;
            height: 24px;
        }
    }
</style>